// @owners { team: patient-health }
import { getFamilyMembers } from '~shared/features/family-accounts/selectors/getFamilyMembers';
import { partitionMedicationsByActiveState } from '~shared/features/my-meds/selectors/partitionMedicationsByActiveState';
import getNewTransfers from '~shared/features/transfers/selectors/getNewTransfers';
import { getCurrentUser } from '~shared/features/users/selectors/getCurrentUser';
import { getHasFamily } from '~shared/features/users/selectors/getHasFamily';
import { connect } from '~shared/store';
import { type ReduxStateShared } from '~shared/types';
import MedList from './MedList';

function mapStateToProps(state: ReduxStateShared) {
  const transfers = getNewTransfers(state);
  const { active, inactive, needsAttention } = partitionMedicationsByActiveState(state);
  const familyMembers = getFamilyMembers(state);
  const hasFamily = getHasFamily(state);
  const currentUser = getCurrentUser(state);

  return {
    active,
    familyMembers,
    hasFamily,
    inactive,
    needsAttention,
    transfers,
    currentUser,
  };
}

// @ts-expect-error TS(2345): Argument of type 'typeof MedList' is not assignable to parameter of type 'ComponentType<Matching<{ a... (Delete me to see the full error)
export default connect(mapStateToProps)(MedList);
